import {CoreDI} from '@gongxigames/framework/core/configs';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {ResponsiveHandler} from '@gongxigames/framework/core/fragments/display/responsive';
import {Rectangle} from 'pixi.js';
import {ResizeEventData, ScreenOrientation} from '@gongxigames/framework/core/types';
import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';

export class ResponsiveLayoutService extends UiServiceV2 {
    public static NAME: symbol = CoreDI.ResponsiveLayoutService;

    private rootResponsiveContainerUI?: ResponsiveHandler;
    private cacheRectangle = new Rectangle();
    private disable = false;

    public onInit(): void {
        this.configureResponsive();
    }

    public onSetupEvents(): void {
        this.emitter.on('CORE.renderLoop.beforeRender', this.onUpdateResponsive.bind(this));
        this.emitter.on('CORE.input.keydown', this.onToggleUpdate.bind(this));
        this.emitter.on('CORE.screen.resize', this.onResize.bind(this));
    }

    private configureResponsive() {
        const {stage_rootContainer_ui} = slotStore.values();

        this.rootResponsiveContainerUI = new ResponsiveHandler(stage_rootContainer_ui);
        this.rootResponsiveContainerUI.root.responsive = {
            box: {width: '100%', height: '100%'},
        };
    }

    private onUpdateResponsive() {
        const responsiveHandler = this.rootResponsiveContainerUI;
        const {stage_safeZoneState_ui: safeZone} = slotStore.values();

        if (responsiveHandler && !this.disable) {
            responsiveHandler.update(safeZone.calcInSafeFader(this.cacheRectangle));
        }
    }

    private onToggleUpdate(event: KeyboardEvent) {
        if(event.code === 'KeyU') {
            this.disable = !this.disable;
        }
    }

    private onResize(event: ResizeEventData) {
        const isPortrait = event.orientation === ScreenOrientation.PORTRAIT;

        slotStore.stage_isPortrait.value = isPortrait;
        slotStore.stage_isLandscape.value = !isPortrait;
    }
}
